export default __webpack_public_path__ + "static/media/tablet-banner.1040fb5e.png";